var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6763 8.31627C17.2488 6.56124 14.7512 6.56124 14.3237 8.31627C14.2599 8.57999 14.1347 8.82492 13.9583 9.03112C13.7819 9.23732 13.5594 9.39897 13.3087 9.50291C13.0581 9.60684 12.7865 9.65014 12.5159 9.62927C12.2454 9.60839 11.9836 9.52394 11.7519 9.38279C10.2083 8.44227 8.44201 10.2086 9.38254 11.7521C9.99006 12.7488 9.45117 14.0494 8.31713 14.325C6.56096 14.7514 6.56096 17.25 8.31713 17.6753C8.58093 17.7392 8.8259 17.8645 9.03211 18.041C9.23831 18.2175 9.39991 18.4402 9.50375 18.691C9.6076 18.9418 9.65074 19.2135 9.62968 19.4841C9.60862 19.7547 9.52394 20.0165 9.38254 20.2482C8.44201 21.7917 10.2083 23.558 11.7519 22.6175C11.9836 22.4761 12.2454 22.3914 12.516 22.3704C12.7866 22.3493 13.0583 22.3924 13.3091 22.4963C13.5599 22.6001 13.7826 22.7617 13.9591 22.9679C14.1356 23.1741 14.2609 23.4191 14.3248 23.6829C14.7512 25.439 17.2499 25.439 17.6752 23.6829C17.7393 23.4192 17.8647 23.1744 18.0413 22.9684C18.2178 22.7623 18.4405 22.6008 18.6912 22.497C18.9419 22.3932 19.2135 22.35 19.4841 22.3709C19.7546 22.3919 20.0164 22.4764 20.2481 22.6175C21.7917 23.558 23.558 21.7917 22.6175 20.2482C22.4763 20.0165 22.3918 19.7547 22.3709 19.4842C22.35 19.2136 22.3932 18.942 22.497 18.6913C22.6008 18.4406 22.7623 18.2179 22.9683 18.0414C23.1744 17.8648 23.4192 17.7394 23.6829 17.6753C25.439 17.2489 25.439 14.7502 23.6829 14.325C23.4191 14.2611 23.1741 14.1358 22.9679 13.9593C22.7617 13.7828 22.6001 13.5601 22.4962 13.3093C22.3924 13.0585 22.3493 12.7868 22.3703 12.5162C22.3914 12.2456 22.4761 11.9838 22.6175 11.7521C23.558 10.2086 21.7917 8.44227 20.2481 9.38279C20.0164 9.52418 19.7546 9.60886 19.484 9.62992C19.2134 9.65098 18.9417 9.60784 18.6909 9.504C18.4401 9.40016 18.2174 9.23856 18.0409 9.03236C17.8644 8.82616 17.7391 8.58119 17.6752 8.3174L17.6763 8.31627Z",
    stroke: "#6B7A99",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16Z",
    stroke: "#6B7A99",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#C3CAD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.89f9f67fb6d460679e6faef813576f24.svg";
export { ForwardRef as ReactComponent };